import InnerComponent from '@Components/Inventory/Indent/CreateIndent';
import orgContainer from '@Components/AppContainer';

const CreateIndent = () => ((orgContainer(InnerComponent)));
export default CreateIndent;
